import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import { AppContext } from '../../../context/app-context';
import { msgAlert } from '../../../helper';
import AssessmentHeader from '../../Diet/component/AssessmentHeader';
import CheckBox from '../../Diet/component/CheckBox';
import heartHealth from '../../../assets/images/heart-health.svg'

const Assessment = () => {

  let navigate = useNavigate();
  const location = useLocation();
  const [state, dispatch] = useContext(AppContext);
  const [checkboxList, setCheckboxList] = useState(state.healthConditions);
  const [textboxValue, setTextboxValue] = useState();
  
  let {activatePlan} = state?.activatePlan
  
  if(activatePlan){
    localStorage.setItem("activatePlan", activatePlan)
  }


  const handleOnChange = (event,option) => {
    
    if(option.label === 'Other' && !event.target.checked)
      setTextboxValue();

    let checkboxListLet = checkboxList;
    if(option.label === 'None') {
      checkboxListLet.forEach(chkItem=>{
        if(chkItem.label !== option.label){
          chkItem.isChecked = false;
        }else {
          chkItem.isChecked = event.target.checked;
        }
      })
    }else {
      checkboxListLet.forEach(chkItem=>{
        if(chkItem === option){
          chkItem.isChecked = event.target.checked;
        }
        if(chkItem.label === 'None'){
          chkItem.isChecked = false;
        }
      })
    }
    setCheckboxList([...checkboxListLet]);
    dispatch({
      type: "HEALTH_CONDITIONS",
      payload: checkboxListLet
    });
  }

  const handleOnClick = () => {
    if(checkboxList.some(obj => obj.label === 'Other' && obj.isChecked)) {
      if(textboxValue && textboxValue?.trim()) {
        let checkboxListLet = checkboxList;
        checkboxListLet.forEach(chkItem=>{
          if(chkItem.value === 'other'){
            chkItem.value = textboxValue;
          }
        })
        setCheckboxList([...checkboxListLet]);
        dispatch({
          type: "HEALTH_CONDITIONS",
          payload: checkboxListLet
        });
        navigate(`/dietPlan/planType`); 

      }else {
        msgAlert('Required', 'Please specify your condition', true, true);
      }
      
    }else {
      navigate(`/dietPlan/planType`);
    }
  }

  const onchangeTextbox = e => setTextboxValue(e.target.value);

  return(
    <>
      <AssessmentHeader progressPer={25} />
      <Container className='diet-container mb-6-rem'>
        <div className="mt-5 mb-3 img-container">
          <img src={heartHealth} alt='' />
        </div>
        <h4 className='header-text'>What is more important for you to manage?</h4>
        <h2 className='assessment-page-title'>For your AI diet plan what condition would you want your plan to focus on?</h2>
          <CheckBox
            checkboxList={checkboxList}  
            onChange={handleOnChange}
            onchangeTextbox={onchangeTextbox}
            textboxValue={textboxValue}
          />
        <Button className='diet-payment-btn btn-diet-done' onClick={handleOnClick} disabled={checkboxList.filter(e => e.isChecked === true).length === 0}>Next</Button>
      </Container>
    </>
  );
}

export default Assessment;